import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { ValidarToken } from 'src/app/validators/valida-datos';

@Component({
  selector: 'app-chat-mdl',
  templateUrl: './chat-mdl.page.html',
  styleUrls: ['./chat-mdl.page.scss'],
})
export class ChatMdlPage implements OnInit {

  @Input() conversacion: any;
  @Input() agente: string;
  @Input() cliente: string;
  @Input() nombreCliente: string;
  loading: any;
  chat: any;
  arrConver: any;
  classUser: any;
  nombreArchivo 
  enlaceDescarga
  canalInicial: any;
  canal: any;
  canales: any;
  idAdmin: number;
  constructor(
    private serviceWa: WhatsappService,
    private loadingController: LoadingController,
    private toastCtrl: ToastController,
    private modal: ModalController,
    private formatdate: DatePipe,
    private storage: Storage
  ) { }

  ngOnInit() {
    this.chat = [];
    this.arrConver = [];
    this.presentLoading('Cargando chat...');
    setTimeout(() => {
      this.getCanal();
    }, 500);
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canales = await this.storage.get('canales').then();
    // console.log(this.canales, 'canales ');
    this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec == this.canal.idAdmin_sec);
    this.idAdmin = this.canalInicial.canale.idAdmin_sec;
    this.classUser = this.canalInicial;
    this.getChat();
    // console.log(this.canal.url_back, 'url de back desde storage');
  }

  getChat() {
    const query = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      id_admin: this.conversacion.id_admin,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      id_cliente: this.conversacion.id_cliente,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      id_agente: this.conversacion.id_agente,
      conversacion: this.conversacion.conversacion,
    };
    // console.log(this.classUser);
    this.serviceWa.getChat(query, this.classUser.id, this.classUser.rol,
      this.classUser.token, this.classUser.canale.url_back).subscribe(
      (res: any)=>{
      // console.log(res);
      this.loading.dismiss();

        const {status, message} = res;
        if(status ==='success'){
         const {chats} = res;
         this.chat = chats;

         this.formatTable(this.chat);
        //  console.log(this.conversaciones);
         this.presentToast('Datos encontrados!', 'success');
        }
        else{
         this.presentToast('No se encontrarón conversaciones', 'danger');
        }
    },
    erro => {
      console.log(erro);
      this.loading.dismiss();
    });
  }

  back() {
    this.modal.dismiss();
  }

  formatTable(conversaciones) {
    this.arrConver = conversaciones.map((conver) =>( {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Telefono: this.cliente,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Nombre: this.nombreCliente,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Fecha de Envio': this.formatdate.transform(conver.createdAt, 'dd/MM/yyyy HH:mm:ss'),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Mensaje: conver.mensaje,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Agente: this.agente,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Enviado por': conver.autor,
    }));
  }

  descargar() {
    this.serviceWa.exportAsExcelFile(this.arrConver, `chat-${this.cliente}-${this.agente}-${this.formatdate.transform(new Date(),
      'dd-MM-yyyy-HH-mm-ss')}`);
      console.log(this.arrConver, this.cliente, this.agente, this.formatdate );
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner:'dots',
      message: mensaje,
    });
  await this.loading.present();
}

async presentToast(message, color) {
  const toast = await this.toastCtrl.create({
    message,
    duration: 3000,
    color
  });
  toast.present();
}


revisarImgSrc(mensaje) {
  this.nombreArchivo = null;
  const mensaje1 = mensaje.split('.');
  //console.log(mensaje1[0])
  if (mensaje1[0] === 'https://planitwhatsapp' && mensaje1[1] === 's3') {
    this.enlaceDescarga = mensaje;

    const indiceFormato = mensaje1.length - 1;
    const indiceNombreArchivocompleto = mensaje1.length - 2;
    const nombreArchivoCompleto = mensaje1[indiceNombreArchivocompleto];
    const arrayNombreCompletoArchivo = nombreArchivoCompleto.split('-');
    const indiceNombrArchivo = arrayNombreCompletoArchivo.length - 1;

    let tipoArchivo = mensaje1[indiceFormato];
    //'jpg', 'png', 'jpeg', 'JPG', 'PNG', 'JPEG'

    //console.log(tipoArchivo)

    if(tipoArchivo.split('%')[0] ==='ogg'){
        tipoArchivo = 'ogg';
    }

    //-----------si es imagen--------------------------------------------------
    if (
      tipoArchivo === 'jpg' ||
      tipoArchivo === 'png' ||
      tipoArchivo === 'jpeg' ||
      tipoArchivo === 'JPG' ||
      tipoArchivo === 'PNG' ||
      tipoArchivo === 'JPEG'
    ) {
      this.nombreArchivo =
        arrayNombreCompletoArchivo[indiceNombrArchivo] + '.' + tipoArchivo;
      return 1;
    }

    //----------------------si es video-------------------------------------------

    if (
      tipoArchivo === 'MP4' ||
      tipoArchivo === 'mp4' ||
      tipoArchivo === '3gp' ||
      tipoArchivo === '3GP'
    ) {
      this.nombreArchivo =
        arrayNombreCompletoArchivo[indiceNombrArchivo] + '.' + tipoArchivo;
      return 3;
    }



       //----------------------si es audio-------------------------------------------

       if (
        tipoArchivo === 'ogg'
      ) {
        this.nombreArchivo =
          arrayNombreCompletoArchivo[indiceNombrArchivo] + '.' + tipoArchivo;
        return 4;
      }



    //--------------------si es archivo------------------------------------------------------------
    else {
      this.nombreArchivo =
        arrayNombreCompletoArchivo[indiceNombrArchivo] + '.' + tipoArchivo;

      return 2;
    }
  } 
  else if(mensaje1[0] ==='https://maps'){
//console.log('cae caso de latitud')
  return 5
    
  }
  
  else return 0;

  
}

descargarArchivo(url) {
  // console.log(url);
  window.location.href = url;
}

}
